var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.531 1.414a.75.75 0 0 1 .938 0l5 4A.75.75 0 0 1 13.75 6v7a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75V8.75h-2.5V13a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V6a.75.75 0 0 1 .281-.586l5-4zM3.75 6.36v5.89h1.5V8A.75.75 0 0 1 6 7.25h4a.75.75 0 0 1 .75.75v4.25h1.5V6.36L8 2.96l-4.25 3.4z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export default ForwardRef;